module.exports = function bhattacharyya(a, b) {
    var ii = a.length,
        ans = 0;
    for (var i = 0; i < ii ; i++) {
        ans += Math.sqrt(a[i] * b[i]);
    }
    return - Math.log(ans);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-distance/src/distances/bhattacharyya.js
 ** module id = 54
 ** module chunks = 0
 **/